/**
 * 전화번호 하이픈 표준형 정규화 — 백엔드 @core/phone 과 동일 규칙.
 * (두 저장소가 분리돼 있어 공용 패키지 대신 최소 복제)
 *
 * 낙관적 표시가 서버 저장값과 일치하도록 프론트에서도 적용.
 */
export function normalizePhone(raw: string | null | undefined): string | null {
  if (raw == null) return null;
  const s = raw.trim();
  if (s === '') return null;
  const d = s.replace(/\D/g, '');
  if (d === '') return null;
  if (d.length === 11 && d.startsWith('01')) return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`;
  if (d.length === 10 && d.startsWith('01')) return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
  if (d.length === 10 && d.startsWith('02')) return `02-${d.slice(2, 6)}-${d.slice(6)}`;
  if (d.length === 9  && d.startsWith('02')) return `02-${d.slice(2, 5)}-${d.slice(5)}`;
  if (d.length === 11) return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`;
  if (d.length === 10) return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
  return s;
}
